import { render, staticRenderFns } from "./SZ_homePageNew.vue?vue&type=template&id=047bf29c&scoped=true&"
import script from "./SZ_homePageNew.vue?vue&type=script&lang=js&"
export * from "./SZ_homePageNew.vue?vue&type=script&lang=js&"
import style0 from "./SZ_homePageNew.vue?vue&type=style&index=0&id=047bf29c&prod&scoped=true&lang=css&"
import style1 from "./SZ_homePageNew.vue?vue&type=style&index=1&id=047bf29c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047bf29c",
  null
  
)

export default component.exports